import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

export const equipmentColumns = (handleUpdate, handleDelete) => [
  {
    field: "categoryName",
    headerName: "Kategori",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "brandName",
    headerName: "Marka",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "modelName",
    headerName: "Model",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "serialNumber",
    headerName: "Seri Numarası",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "serviceTag",
    headerName: "Servis Etiketi",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "inUse",
    headerName: "Kullanımda Mı",
    minWidth: 120,
    flex: 1,
    sortable: false,
    filterable: false,
    align: "center",
    headerAlign: "center",
    valueGetter: (value, row) =>
      row && row.inUse ? "Kullanımda" : "Boşta",
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "İşlemler",
    flex: 1,
    sortable: false,
    filterable: false,
    disableExport: true,
    renderCell: (params) => (
      <div style={{ display: "flex", gap: 8, marginTop: 5 }}>
        <IconButton
          variant="contained"
          color="secondary"
          onClick={() => handleUpdate(params.row)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          variant="contained"
          color="error"
          onClick={() => handleDelete(params.row)}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    ),
  },
];
